import { INTERFRAMEMESSAGES } from "./InterframeMessages";
import { uniqueValues } from "./arrayHelper";
function logIfDebug(message) {
    if (window !== undefined && typeof (window.DEBUG) !== "undefined" && window.DEBUG === true) {
        console.log(message);
    }
}
export class EventHook {
    constructor(eventnames, callback) {
        if (typeof eventnames === "string") {
            this.eventnames = [eventnames];
        }
        else {
            this.eventnames = eventnames;
        }
        this.callback = callback;
    }
}
export class EventListener {
    constructor() {
        this.eventHooks = [];
        EventVerteiler.subscribe(this);
    }
    getSubscribedEvents() {
        return uniqueValues(this.eventHooks.reduce((carry, h) => carry.concat(h.eventnames), []));
    }
    addEventListener(eventnames, f) {
        this.eventHooks.push(new EventHook(eventnames, f));
        return this;
    }
    removeAllEventListeners() {
        this.eventHooks = [];
        return this;
    }
    removeEventListener(eventname) {
        this.eventHooks.forEach(h => {
            h.eventnames = h.eventnames.filter(n => n !== eventname);
        });
        this.eventHooks = this.eventHooks.filter(h => h.eventnames.length > 0);
        return this;
    }
    receiveEvent(eventName, data) {
        this.eventHooks.forEach(h => {
            if (EventListener.isHookForEventName(h, eventName)) {
                EventVerteiler.eventReceived(eventName, this.constructor.name);
                h.callback(data);
            }
        });
    }
    static isHookForEventName(hook, eventname) {
        return hook.eventnames.indexOf(eventname) > -1;
    }
    receiveEventReturnResult(eventName, data) {
        for (const hook in this.eventHooks) {
            if (EventListener.isHookForEventName(this.eventHooks[hook], eventName)) {
                return this.eventHooks[hook].callback(data);
            }
        }
        return null;
    }
    isSubscribedToEvent(eventName) {
        return this.eventHooks.some(h => h.eventnames.indexOf(eventName) > -1);
    }
}
export class EventVerteiler {
    static setResourceManager(resourceManager) {
        EventVerteiler.resourceManager = resourceManager;
    }
    static setErrorHandler(errorHandler) {
        EventVerteiler.errorHandler = errorHandler;
    }
    static registerResource(args) {
        return EventVerteiler.resourceManager.registerResource(args);
    }
    static createTask(taskname) {
        return EventVerteiler.resourceManager.createTask(taskname);
    }
    static handleError(severity, happenedHere, messageToDisplay, callbackAfterMessageClose) {
        EventVerteiler.errorHandler.handleError(severity, happenedHere, messageToDisplay, callbackAfterMessageClose);
    }
    static handleErrorTranslated(severity, happenedHere, messageID, messageAddition = "", callbackAfterMessageClose) {
        EventVerteiler.errorHandler.handleError(severity, happenedHere, EventVerteiler.errorHandler.translate(messageID, messageID) + " " + messageAddition, callbackAfterMessageClose);
    }
    static broadcast(eventName, data) {
        EventVerteiler.log.push(eventName);
        EventVerteiler.eventListenerObjects.forEach(l => {
            l.receiveEvent(eventName, data);
        });
    }
    static requestData(eventName, data) {
        EventVerteiler.log.push("requestData " + eventName);
        return new Promise((resolve, reject) => {
            for (const l in this.eventListenerObjects) {
                if (this.eventListenerObjects[l].isSubscribedToEvent(eventName)) {
                    this.eventListenerObjects[l].receiveEventReturnResult(eventName, data).then((response) => resolve(response)).catch(() => reject());
                    return;
                }
            }
            reject();
        });
    }
    // noinspection JSUnusedGlobalSymbols
    static getEventSubscribers(eventname) {
        return EventVerteiler.eventListenerObjects.reduce((carry, lo) => {
            if (lo.isSubscribedToEvent(eventname)) {
                carry.push(lo.constructor.name);
            }
            return carry;
        }, []);
    }
    // noinspection JSUnusedGlobalSymbols
    static getAllSubscribedEvents() {
        return uniqueValues(this.eventListenerObjects.reduce((carry, el) => carry.concat(el.getSubscribedEvents()), []));
    }
    static subscribe(component) {
        EventVerteiler.eventListenerObjects.push(component);
    }
    static unsubscribe(component) {
        EventVerteiler.eventListenerObjects = EventVerteiler.eventListenerObjects.filter(c => c !== component);
    }
    static receiveMessage(dataObject) {
        logIfDebug("interframeMessage received: " + dataObject.messageText);
        if (EventVerteiler.INTERFRAMEMESSAGES.indexOf(dataObject.messageText) < 0) {
            logIfDebug("interframe Message rejected : " + dataObject.messageText);
            return;
        }
        EventVerteiler.broadcast(dataObject.messageText, dataObject.dataObject);
    }
    static broadcastBlockRequest(blockername, text) {
        EventVerteiler.broadcast("requestScreenBlockEvent", { requester: blockername, message: text });
    }
    static broadcastBlockRequestEnded(blockername) {
        EventVerteiler.broadcast("requestScreenBlockEndEvent", { requester: blockername });
    }
    static eventReceived(eventname, byComponentName) {
        if (EventVerteiler.eventReceivedNotifier !== null) {
            EventVerteiler.eventReceivedNotifier.eventWasReceived(eventname, byComponentName);
        }
    }
}
EventVerteiler.eventListenerObjects = [];
EventVerteiler.log = [];
EventVerteiler.eventReceivedNotifier = null;
EventVerteiler.INTERFRAMEMESSAGES = INTERFRAMEMESSAGES.getMessages();
if (typeof (window) !== "undefined") {
    window.EventVerteiler = EventVerteiler;
}
//# sourceMappingURL=eventVerteiler.js.map